'use client';

import { Input } from '@/components/shadcn/Input';
import { Button } from '@/components/shadcn/Button';
import Link from 'next/link';
import FullScreenLoadingIndicator from '@/components/FullScreenLoadingIndicator';
import { sendEvent } from '@/lib/firebase/analytics/sendEvent';
import { EVENTS } from '@/lib/firebase/analytics/events';
import Image from 'next/image';
import { useEffect } from 'react';
import { deleteCookies } from '@/actions/auth';
import { useAuth } from '../hooks/useAuth';
import { useFormValidation } from '../hooks/useFormValidation';
import { IoEye, IoEyeOff } from 'react-icons/io5';

export default function Login() {
  const {
    email,
    setEmail,
    password,
    setPassword,
    isPasswordVisible,
    setPasswordVisible,
    isLoading,
    handleEmailAuth,
    redirectGoogleAuthPage
  } = useAuth();

  const {
    emailValidationMessages,
    passwordValidationMessages,
    validateEmail,
    validatePassword
  } = useFormValidation();

  useEffect(() => {
    deleteCookies();
  }, []);

  const passwordVisibleBtnStyle =
    'absolute right-3.5 top-7 h-6 w-5 shrink-0 cursor-pointer text-gray-400';

  return (
    <>
      <div className="mx-auto min-h-[calc(100vh-294px)] w-[84%] py-[60px] pb-[120px] md:w-[430px] md:pt-[120px]">
        <h3 className="mb-4 pb-[32px] text-center text-[19px] font-bold">
          ログイン
        </h3>
        <Input
          onChange={({ target: { value } }) => {
            setEmail(value);
            validateEmail(value);
          }}
          required
          type="email"
          name="email"
          id="email"
          placeholder="メールアドレス"
        />
        {emailValidationMessages.map(emailValidationMessage => (
          <p
            key={emailValidationMessage}
            className="text-[12px] font-semibold text-[#d92f2b]"
          >
            {emailValidationMessage}
          </p>
        ))}
        <div className="relative">
          <Input
            className="mt-4"
            onChange={({ target: { value } }) => {
              setPassword(value);
              validatePassword(value);
            }}
            required
            type={isPasswordVisible ? 'text' : 'password'}
            name="password"
            id="password"
            placeholder="パスワード(半角英数字8文字以上)"
          />
          {isPasswordVisible ? (
            <IoEye
              className={passwordVisibleBtnStyle}
              aria-hidden="true"
              onClick={() => setPasswordVisible(false)}
            />
          ) : (
            <IoEyeOff
              className={passwordVisibleBtnStyle}
              aria-hidden="true"
              onClick={() => setPasswordVisible(true)}
            />
          )}
        </div>
        {passwordValidationMessages.map(passwordValidationMessage => (
          <p
            key={passwordValidationMessage}
            className="text-[12px] font-semibold text-[#d92f2b]"
          >
            {passwordValidationMessage}
          </p>
        ))}
        <Button
          className="mx-auto mt-6 flex w-4/5 rounded-full py-[24px] font-semibold text-white bg-gradient-report-header md:w-3/5 md:py-[30px]"
          color="primary"
          type="submit"
          onClick={handleEmailAuth}
          disabled={
            !email ||
            !password ||
            !!emailValidationMessages.length ||
            !!passwordValidationMessages.length
          }
        >
          ログイン
        </Button>
        <div className="pt-[30px] text-center">
          <Link
            className="border-b border-solid border-[#555] pb-[2px] text-[#555] no-underline"
            href="/setting/password"
            prefetch={false}
          >
            パスワードを忘れた場合
          </Link>
        </div>
        <div className="mt-4 flex">
          <div className="my-6 h-0 w-full border" />
          <div className="ml-3 w-32 leading-[48px]">または</div>
          <div className="my-6 h-0 w-full border" />
        </div>
        <Button
          variant="outline"
          className="mx-auto my-4 flex w-4/5 rounded-full border-gray-300 bg-white py-[24px] font-bold text-black md:w-3/5 md:py-[30px]"
          onClick={redirectGoogleAuthPage}
        >
          <Image
            src="static/images/icons/google.svg"
            width={20}
            height={20}
            alt="Google"
          />
          <span className="pl-2">Googleでログイン</span>
        </Button>
      </div>
      {isLoading ? <FullScreenLoadingIndicator /> : null}
    </>
  );
}
